import { render, staticRenderFns } from "./datalayer.vue?vue&type=template&id=ebe989a6"
import script from "./datalayer.vue?vue&type=script&lang=js"
export * from "./datalayer.vue?vue&type=script&lang=js"
import style0 from "./datalayer.vue?vue&type=style&index=0&id=ebe989a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports